<template  lang="pug">
  div.popper(:class="[status]")
    slot
</template>

<script>
import popper from '../../src/mixins/popper.js'
export default {
  name: 'KmPopper',
  mixins: [popper]
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/ui/components/km-popper/main.vue